export default "__VITE_ASSET__FdQkPwHl__"